import React from 'react';

import {
  FormGroupStyled,
  FormLabelStyled,
  CheckboxStyled,
  LabelStyled,
  StackStyled,
  TitleStyled,
  DescriptionStyled,
} from './styles';

const CheckboxControl = ({
  value,
  onChange,
  defaultChecked,
  label,
  infinityList,
  title,
  description,
  ...props
}) => (
  <FormGroupStyled infinityList={infinityList}>
    <FormLabelStyled
      control={
        <CheckboxStyled
          value={value}
          defaultChecked={defaultChecked}
          onChange={onChange}
        />
      }
      label={
        label ? (
          <LabelStyled component="span">{label}</LabelStyled>
        ) : null || (title && description) ? (
          <StackStyled>
            <TitleStyled>{title}</TitleStyled>
            <DescriptionStyled component="span">
              {description}
            </DescriptionStyled>
          </StackStyled>
        ) : null
      }
      {...props}
    />
  </FormGroupStyled>
);

export default CheckboxControl;
